<div class="confirmation" *ngIf="creditType === '1' || (creditType === '9' && country != 'co')">
  <h2 class="title">Aviso de privacidad simplificado</h2>
  <div class="text">
    <p>
      Para grupo empresarial VEMO (en adelante “Grupo VEMO”) es indispensable el cumplimiento a lo
      previsto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares,
      su reglamento, lineamientos y demás normatividad aplicable (en adelante “Legislación de Datos Personales”)
      ponemos a tu disposición el presente aviso de privacidad simplificado (en lo subsecuente “Aviso Simplificado”).
    </p>
    <p style="font-style: italic; text-decoration: underline;">Domicilio de Grupo VEMO:</p>
    <p>
      Grupo VEMO señala como domicilio convencional, para los efectos relacionados con el presente Aviso Simplificado,
      el ubicado en Campos Elíseos 345, Piso 9, Polanco V Sección, Miguel Hidalgo, C.P. 11560, Ciudad de México.
    </p>
    <p style="font-style: italic; text-decoration: underline;">Finalidades:</p>
    <p>
      Grupo VEMO hace de su conocimiento que sus datos personales, incluyendo los sensibles, que actualmente o en el
      futuro obren en nuestras bases de datos, serán tratados y/o utilizados para la prestación de nuestros servicios,
      para actividades administrativas, laborales y contractuales, con fines de identificación para la prestación de los
      servicios, con fines estadísticos, de comunicación, promoción, difusión (vía telefónica, correo electrónico o a través
      de los medios que determine Grupo VEMO) de productos y/o servicios (incluyendo los relativos a las App de movilidad con
      que Grupo VEMO tenga relación), para atender requerimientos de las autoridades o para proteger y defender los derechos de
      Grupo VEMO, esto siempre en términos de lo dispuesto por la Legislación de Datos Personales.
    </p>
    <p>Al aceptar el presente Aviso Simplificado, Usted acuerda que las Apps de movilidad con que Grupo VEMO tenga
      relación darán tratamiento a sus datos personales, de conformidad con lo establecido en los avisos de privacidad
      respectivos. Asimismo, Usted da su consentimiento para que las Apps de movilidad con que Grupo VEMO tenga relación
      compartan sus datos personales con Grupo VEMO para los propósitos establecidos en el presente Aviso Simplificado.
    </p>
    <p style="font-style: italic; text-decoration: underline;">Procedimiento para ejercer los derechos ARCO:</p>
    <p>
      Los titulares podrán ejercer sus derechos ARCO (Acceso, Rectificación, Cancelación y Oposición) que les confiere
      la Ley, mediante una solicitud que ponemos a su disposición <a href="https://vemovilidad.com/wp-content/uploads/2025/02/Form_DerechosARCO-VEMO.pdf" target="_blank">aquí</a>, completándolo en línea para posteriormente imprimirla,
      establecer su firma al calce de la misma y finalmente enviarla en formato electrónico a la dirección de correo electrónico
      <a href="mailto:legal@vemo.com.mx">legal@vemo.com.mx</a>, estableciendo como asunto “Ejercicio de derechos sobre datos personales” y acompañando lo siguiente:
    </p>
    <ul>
      <li>Copia de los documentos que acrediten su identidad (identificación oficial vigente con fotografía) y, en su caso, la de su representante legal, así como el documento que acredite su personería, conforme a los términos establecidos en la Legislación de Datos Personales; y</li>
      <li>Cualquier otro elemento, dato o documento que facilite la localización de sus datos personales.</li>
    </ul>
    <p style="font-style: italic; text-decoration: underline;">Modificaciones al Aviso de privacidad:</p>
    <p>
      Grupo VEMO, en cualquier tiempo, podrá hacer las modificaciones necesarias al presente Aviso Simplificado
      para adecuar, actualizar, mejorar o atender nuevas disposiciones legales. Por lo anterior, Grupo VEMO se compromete
      a hacer de su conocimiento cualesquiera modificaciones que se lleguen a realizar a través de su
      página web <a target="_blank" href="https://vemovilidad.com/">https://vemovilidad.com/</a>, en la sección “Aviso de privacidad
      México”.
    </p>
    <p>Si desea conocer nuestro aviso de privacidad integral, lo podrá consultar <a target="_blank" href="https://vemovilidad.com/aviso-de-privacidad-mexico/">aquí.</a></p>
  </div>
  <div class="button-close">
    <button mat-raised-button [mat-dialog-close]="true">Cerrar</button>
  </div>
</div>

<div class="confirmation" *ngIf="creditType === '9' && country == 'co'">
  <h2 class="title">POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES DE</h2>
  <h2 class="title">DAE MOBILITY COLOMBIA S.A.S</h2>
  <div class="text">
    <ol>
      <li>
        <h2>¿QUIÉNES SOMOS?</h2>
        <p>
          DAE Mobility Colombia S.A.S., sociedad comercial identificada con NIT
          901.545.539-5 (en adelante la “Compañía” o “VEMO”) es una empresa
          cleantech que busca acelerar la adopción de tecnologías de movilidad
          limpia a través de soluciones integrales que incluye: (i) vehículos,
          (ii) infraestructura de recarga y (iii) tecnología e inteligencia de
          datos para gestión de flotas, como componentes del sistema de
          movilidad limpia.
        </p>
        <br />
        <p>
          En esta política nos denominaremos a nosotros mismos "VEMO”,
          “Nosotros” o la “Compañía”. Nosotros somos responsables (quién
          determina qué se hace con tus datos personales, de conformidad con la
          Ley 1581 de 2012 - LGPDP) del tratamiento y uso en general de tus
          Datos Personales a través de nuestra página web, las aplicaciones
          móviles de nuestros aliados, durante el arrendamiento y uso de
          nuestros vehículos y a través de nuestros canales de atención al
          cliente.
        </p>
        <br />
        <p>A continuación, nuestra información para tu conocimiento:</p>
        <table>
          <tr>
            <td>Razón Social</td>
            <td>DAE Mobility Colombia S.A.S.</td>
          </tr>
          <tr>
            <td>NIT</td>
            <td>901.545.539-5</td>
          </tr>
          <tr>
            <td>Dirección</td>
            <td>Calle 93 No. 15-40 Piso 4</td>
          </tr>
          <tr></tr>
        </table>
      </li>

      <li>
        <h2>POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES</h2>
        <p>
          Para VEMO tu privacidad es primordial. Este documento explicará el
          enfoque de VEMO al tratar información de carácter personal (cualquier
          información vinculada o que pueda asociarse a una o varias personas
          naturales determinadas o determinables) de las personas con las que
          interactuamos a través de cualquiera de nuestros canales previstos por
          VEMO, el tipo de datos que trataremos y las condiciones en que se
          custodiarán los datos personales que nos hayas proporcionado. VEMO se
          encuentra comprometida a cumplir en todo momento con la normatividad
          vigente en Colombia en materia de protección de datos personales,
          garantizando el ejercicio de sus derechos de habeas data.
        </p>
        <br />
        <p>
          La Política de Tratamiento tiene como objeto proteger el derecho
          constitucional del Habeas Data que tienen todas las personas para
          conocer, actualizar y rectificar la información personal que se haya
          recogido y almacenado en las distintas bases de datos de VEMO. Los
          Datos Personales sólo serán recolectados y tratados, cuando así haya
          sido autorizado previamente por su titular, y se garantice su
          tratamiento bajo los parámetros anotados antes. Así mismo, detalla los
          lineamientos generales corporativos que se tienen en cuenta con el fin
          de proteger los datos personales de los titulares, las finalidades de
          tratamiento de la información, el área responsable de atender las
          quejas y reclamos, y los procedimientos que se deben agotar para
          conocer actualizar, rectificar y suprimir la información y los
          respectivos canales para que estos puedan ejercerlos.
        </p>
      </li>
      <li>
        <h2>DEFINICIONES</h2>
        <p>
          Estos son los términos que utilizaremos a lo largo de este documento,
          en el cual explicaremos la forma como tratamos tu información
          personal.
        </p>
        <ol type="a">
          <li>
            Autorización: Consentimiento previo, expreso e informado del titular
            para llevar a cabo el tratamiento de datos personales.
          </li>
          <li>
            Base de datos: Conjunto organizado de datos personales que sea
            objeto de tratamiento.
          </li>
          <li>
            Consentimiento del titular: Es una manifestación de la voluntad,
            informada, libre e inequívoca, a través de la cual el titular de los
            datos de carácter personal autoriza a un tercero a tratar sus datos
            personales.
          </li>
          <li>
            Consulta: El derecho de los Titulares o sus causahabientes a
            consultar los Datos Personales del Titular que repose en cualquier
            base de datos. El responsable del tratamiento o el encargado del
            tratamiento deberán suministrar la información contenida en el
            registro individual o que esté vinculada con la identificación del
            titular.
          </li>
          <li>
            Dato personal: Cualquier información vinculada o que pueda asociarse
            a una o varias personas naturales determinadas o determinables.
          </li>
          <li>
            Dato público: Es el dato que no sean semiprivados o privados, de
            conformidad con la ley colombiana. Son públicos, entre otros, los
            datos contenidos en documentos públicos, gacetas y boletines
            judiciales, sentencias judiciales debidamente ejecutoriadas que no
            estén sometidas a reserva y los relativos al estado civil de las
            personas.
          </li>
          <li>
            Dato semiprivado: Es semiprivado el dato que no tiene naturaleza
            íntima, reservada, ni pública y cuyo conocimiento o divulgación
            puede interesar no sólo a su titular sino a cierto sector o grupo de
            personas o a la sociedad en general, como el dato financiero y
            crediticio de actividad comercial o de servicios.
          </li>
          <li>
            Dato privado: Es el dato que por su naturaleza íntima o reservada
            sólo es relevante para el titular.
          </li>
          <li>
            Datos sensibles: Se entiende por datos sensibles aquellos que
            afectan la intimidad del Titular o cuyo uso indebido puede generar
            su discriminación, tales como aquellos que revelen el origen racial
            o étnico, la orientación política, las convicciones religiosas o
            filosóficas, la pertenencia a sindicatos, organizaciones sociales,
            de derechos humanos o que promueva intereses de cualquier partido
            político o que garanticen los derechos y garantías de partidos
            políticos de oposición, así como los datos relativos a la salud, a
            la vida sexual, y los datos biométricos, tales como fotografías,
            grabaciones de sistemas de videovigilancia entre otros.
          </li>
          <li>
            Encargado del tratamiento: Es la persona natural o jurídica que
            trata datos personales por cuenta del responsable del tratamiento.
          </li>
          <li>
            Reclamo: Es el ejercicio del derecho a corregir, actualizar o
            suprimir, datos personales, o solicitar que los mismos sean tratados
            conforme a los principios que los tutelan, las leyes estatutarias y
            reglamentos aplicables, y los procedimientos establecidos en este
            Manual.
          </li>
          <li>
            Responsable del tratamiento: Persona natural o jurídica, pública o
            privada, que por sí misma o en asocio con otros, decida sobre la
            base de datos y/o el tratamiento de los datos personales.
          </li>
          <li>
            Tratamiento: Cualquier operación o procedimientos físicos o
            automatizados que permita captar, registrar, reproducir, conservar,
            organizar, modificar, transmitir los datos de carácter personal.
          </li>
          <li>
            Titular de los datos personales: Es la persona natural cuyos datos
            personales son objeto de tratamiento.
          </li>
        </ol>
      </li>
      <li>
        <h2>PRINCIPIOS APLICABLES AL TRATAMIENTO DE TUS DATOS PERSONALES</h2>
        <p>
          Durante el tiempo que tratemos tus datos personales, garantizaremos la
          aplicación de los principios generales establecidos en la LGPDP:
        </p>
        <ol type="a">
          <li>
            Principio de Legalidad: El tratamiento de datos personales debe
            obedecer a una finalidad legítima, por lo cual se dará fiel
            cumplimiento a lo establecido en la LGPDP y en las demás
            disposiciones aplicables.
          </li>
          <li>
            Principio de Finalidad: Siempre trataremos tus datos personales
            conforme a una finalidad legítima la cual será previamente informada
            al titular de los datos personales.
          </li>
          <li>
            Principio de Libertad: Solo trataremos tus datos personales cuando
            cuente con el consentimiento previo, expreso e informado del titular
            o exista una excepción de conformidad con la LGPDP. Como titular
            siempre podrás negarte al tratamiento de tus datos sensibles.
          </li>
          <li>
            Principio de Veracidad o Calidad: Los datos personales que
            trataremos deberán ser veraces, completos, exactos, actualizados,
            comprobables y comprensibles.
          </li>
          <li>
            Principio de Transparencia: Garantizamos que en cualquier momento y
            sin restricciones el titular de los datos personales o su
            representante legal podrá acceder a la información sobre sus datos
            personales y la forma como son tratados.
          </li>
          <li>
            Principio de Acceso y Circulación Restringida: El tratamiento de sus
            datos personales se realizará solamente por las personas a quien
            usted haya autorizado y/o a quienes deba compartirse la información
            de conformidad con la LGPDP.
          </li>
          <li>
            Principio de Seguridad: La información sujeta a tratamiento por
            nuestra parte, se manejará con las medidas técnicas, humanas y
            administrativas necesarias para otorgar seguridad a los registros,
            evitando su adulteración, pérdida, consulta, uso o acceso no
            autorizado o fraudulento.
          </li>
          <li>
            Principio de Confidencialidad: Nos comprometemos a que las personas
            que intervengan en el tratamiento de tus datos personales que no
            sean públicos, se encontrarán obligadas a garantizar la reserva de
            la información, incluso después de finalizada su relación con alguna
            de las labores que comprende el tratamiento, pudiendo sólo realizar
            suministro o comunicación de datos personales cuando ello
            corresponda al desarrollo de las actividades autorizadas.
          </li>
          <li>
            Principio de Responsabilidad Demostrada: Aquel que se basa en el
            enfoque del reconocimiento y del compromiso de las organizaciones a
            los efectos de incrementar los estándares de protección para
            procurar y garantizar a las personas un tratamiento adecuado de tus
            datos personales. Este principio comporta para nosotros una
            obligación de rendir cuentas sobre tus actividades en materia de
            protección de datos personales, aceptar responsabilidad sobre ellas
            y divulgar los resultados de manera transparente.
          </li>
        </ol>
      </li>
      <li>
        <h2>¿QUÉ DATOS RECOPILAMOS Y CÓMO LO UTILIZAMOS?</h2>
        <h3>5.1. Formas de recolección de los datos personales</h3>
        <p>
          La Compañía recopila la Información directamente de usted, del uso de
          las aplicaciones y plataformas de nuestros aliados, así como de
          cualquier tercero al que usted haya autorizado a compartir dicha
          información con nosotros.
        </p>
        <ol type="a">
          <li>Directa: Información que usted nos proporciona directamente.</li>
          <li>
            Indirecta: En los casos en que la ley lo permita, la Compañía puede
            recopilar la Información sobre usted de terceros como instituciones
            de información crediticia, entidades gubernamentales, autoridades
            policivas o terceros.
          </li>
          <li>
            Vehículos: Nuestros vehículos cuentan con sistemas de seguridad e
            información que pueden realizar grabaciones en tiempo real. Estas
            grabaciones tienen como finalidad garantizar tu seguridad y la
            integridad del vehículo que tomas en arrendamiento.
          </li>
          <li>
            Sitio Web: Cuando usted visita nuestros sitios web, podemos
            recopilar información de usted automáticamente a través de cookies o
            tecnologías similares.
          </li>
        </ol>
        <h3>5.2. Decisiones automatizadas</h3>
        <p>
          La toma de decisiones automatizada se produce cuando un sistema
          electrónico procesa información o datos personales para tomar una
          decisión sin intervención humana. Parte de nuestros procedimientos,
          especialmente las medidas antifraude y verificación de identidad,
          depende de mecanismos de decisión automatizada y, por lo tanto,
          garantizamos su derecho a solicitar la revisión de cualquier decisión
          tomada basada exclusivamente en el tratamiento automatizado de sus
          datos, de acuerdo con la Ley.
        </p>
        <h3>5.3. Retención de la Información</h3>
        <p>
          La Compañía conservará y utilizará la información personal durante el
          plazo necesario para: (i) cumplir con los fines descritos en esta
          Política; (ii) cumplir con las obligaciones legales y regulatorias que
          sean aplicables; o (iii) cumplir con fines probatorios en
          procedimientos legales, administrativos o de arbitraje.
        </p>
        <br />
        <p>
          Los criterios que se tienen en cuenta para determinar el período de
          conservación incluyen la duración de su relación con la Compañía, los
          períodos de conservación de acuerdo a lo legalmente aplicable y las
          prescripciones legales con respecto a posibles reclamaciones, demandas
          o procedimientos administrativos y de arbitraje en relación con los
          servicios que prestamos.
        </p>
        <h3>5.4. Tipo de Información Recopilada</h3>
        <p>
          A fin de prestarle los servicios, la Compañía puede recopilar y
          procesar la Información de acuerdo con las siguientes categorías, de
          forma manual o automatizada conforme se indica a continuación:
        </p>
        <h3>a) Información acerca de Usted</h3>
        <ul>
          <li>
            Su nombre, número de identificación oficial, dirección física,
            correo electrónico, número telefónico y su fotografía, y otros datos
            biométricos de carácter sensible.
          </li>
          <li>Documentos soporte sobre su identidad.</li>
          <li>
            Información necesaria para realizar el procesamiento de los pagos,
            tales como cuenta bancaria, referencias de entidades financieras,
            entre otras.
          </li>
          <li>
            Datos de contacto con la finalidad de proporcionar un adecuado
            servicio al cliente.
          </li>
          <li>
            Datos biométricos a través de nuestros sistemas de vigilancia en los
            vehículos.
          </li>
        </ul>
        <h3>b) Cookies</h3>
        <ul>
          <li>
            Una cookie es un pequeño archivo de texto que un servidor web coloca
            en su computadora o dispositivo cuando su navegador accede a un
            sitio web. Las cookies almacenan información específica de un
            cliente o sitio web y están diseñadas para crear un registro o
            "recordar" la actividad en línea. VEMO utiliza las cookies para
            garantizar el buen funcionamiento del sitio y ofrecer una
            experiencia de servicios en línea individualizada. Por lo general,
            usted tiene la posibilidad de aceptar o rechazar las cookies. La
            mayoría de los navegadores web le dan la opción de modificar la
            configuración de su navegador para rechazar algunas o todas las
            cookies.
          </li>
        </ul>
      </li>
      <li>
        <h2>
          DERECHOS DE LOS TITULARES DE INFORMACIÓN PERSONAL Y PROCEDIMIENTO
          APLICABLE
        </h2>
        <p>
          <b>6.1. Acceso.</b> Tienes derecho a acceder sin costo alguno a los
          datos personales que tengamos sobre ti. El acceso está permitido
          solamente a los titulares de datos personales que correspondan a
          personas naturales, previa acreditación de su identidad como titular,
          legitimidad, o personalidad de tu representante, poniendo a
          disposición tuya, sin costo o alguna, de manera pormenorizada y
          detallada, los respectivos datos personales tratados, a través de
          cualquier medio de comunicación, Página 7 de 14 incluyendo los
          electrónicos que permitan el acceso directo del titular. El acceso se
          garantizará sujeto a los límites establecidos en artículo 21 del
          Decreto 1377 de 2013.
        </p>
        <br />
        <p>
          <b>6.2. Consulta.</b> En tu calidad de titular puedes consultar tus
          datos personales que se encuentre en nuestras bases de datos. Por
          ello, garantizamos tu derecho de consulta conforme a lo dispuesto en
          la LGPDP. Para efectos de proceder con la consulta, realizaremos una
          autenticación que permita identificarte de manera segura antes de
          revelar cualquier información de carácter personal. Las consultas
          serán tramitadas en un término máximo de diez (10) días hábiles
          contados a partir de la fecha de su presentación.
        </p>
        <br />
        <p>
          <b>6.3. Reclamación.</b> Como titular puedes presentar una reclamación
          si consideras que la información contenida en una base de datos pueda
          ser objeto de corrección, actualización o supresión, o cuando
          adviertas el presunto incumplimiento de cualquiera de los deberes y
          principios contenidos en LGPDP. En tal sentido, podrás presentar
          reclamación de manera directa o en su defecto al encargado del
          tratamiento de tus datos. Para efectos de proceder con la consulta,
          realizaremos una autenticación que permita identificarte de manera
          segura antes de revelar cualquier información de carácter personal. Si
          el reclamo estuviese incompleto, dentro de los cinco (5) días hábiles
          siguientes a la recepción del reclamo te indicaremos para que subsanes
          las fallas o errores. Transcurridos dos (2) meses desde la fecha del
          requerimiento, sin que se presente la información solicitada, se
          entenderá que has desistido del reclamo. En caso de haber un reclamo
          que no sea competencia nuestra, se dará traslado a quien corresponda
          en un término máximo de dos (2) días hábiles e informándole de esta
          situación. Una vez hayamos recibido el reclamo completo, se incluirá
          en la base de datos una leyenda que diga "reclamo en trámite" y el
          motivo del mismo, en un término no mayor a dos (2) días hábiles. Dicha
          leyenda se mantendrá hasta que el reclamo sea decidido. El término
          máximo para resolver la reclamación es de quince (15) días hábiles,
          contados a partir del día siguiente a la fecha de su recibo. Cuando no
          fuere posible atender el reclamo dentro de dicho término, te
          informaremos los motivos de la demora y la fecha en que se atenderá su
          reclamo, la cual en ningún caso podrá superar los ocho (8) días
          hábiles siguientes al vencimiento del primer término.
        </p>
        <br />
        <p>
          <b>6.4. Rectificación y actualización. </b>VEMO se obliga a rectificar
          y actualizar tu información personal incompleta o inexacta de
          conformidad con el procedimiento y lo términos señalados en esta
          sección. Lo anterior, siempre y cuando, no se trate de datos
          contenidos en los registros públicos. Al respecto, tendremos en cuenta
          lo siguiente: 1. en las solicitudes de rectificación y actualización
          de datos personales, debes indicar las correcciones a realizar y
          aportar la documentación que avale su petición; 2. tenemos plena
          libertad de habilitar mecanismos que faciliten el ejercicio de este
          derecho, siempre y cuando lo beneficien como titular de los datos
          personales. En Página 8 de 14 consecuencia, podremos habilitar medios
          electrónicos u otros que consideremos pertinentes y seguros para un
          mejor acceso.
        </p>
        <br />
        <p>
          <b>6.5. Supresión.</b> Tienes el derecho en todo momento a
          solicitarnos la supresión de tus datos personales, siempre y cuando,
          no lo impida una disposición legal o contractual.
        </p>
        <br />
        <p>
          <b>6.6 Revocar la autorización.</b> Puedes revocar en cualquier
          momento, el consentimiento al tratamiento de éstos, siempre y cuando,
          no lo impida una disposición legal o contractual.
        </p>
      </li>
      <li>
        <h2>EJERCICIO DE LOS DERECHOS DEL TITULAR</h2>
        <p>
          En desarrollo de la garantía constitucional de Habeas Data respecto de
          los derechos de mencionados en la sección anterior por parte del
          Titular de los datos personales, sus causahabientes, representantes
          legales y/o apoderados, VEMO habilitará canales de acceso para los
          titulares.
        </p>
        <br />
        <p>
          Todas las comunicaciones, consultas, quejas y/o reclamos deberán ser
          dirigidas al Oficial de Protección de Bases de Datos Personales o al
          Área de Compliance de VEMO por este medio:
        </p>
        <ul>
          <li>
            Atención electrónica: El Titular del dato podrá realizar la
            solicitud por correo: yolanda.villegas@vemo.com.mx
          </li>
        </ul>
        <br />
        <p>Tus derechos pueden ser ejercidos de la siguiente forma:</p>
        <p>
          <b>a) A nombre propio:</b> Ejerces tu derecho directamente realizando
          la consulta o reclamo a VEMO.
        </p>
        <br />
        <p>
          <b>b) A través de apoderado:</b> Ejerces tu derecho a través de un
          apoderado a VEMO. Para estos efectos, debes adjuntar copia del poder
          con la solicitud. Si se llegare a presentar la solicitud por parte de
          una persona que no fuese el titular de la información personal, sin
          cumplir con la presentación del documento idóneo que sustente la
          representación, ésta se tendrá como no presentada y no se dará
          respuesta a dicho requerimiento.
        </p>
        <br />
        <p>
          <b>c) Ejercicio del derecho de menores de edad:</b> Los menores de
          edad deberán ejercer su derecho de Habeas Data a través de quien
          acredite su representación legal.
        </p>
      </li>
      <li>
        <h2>DEBERES Y RESPONSABILIDADES DE VEMO</h2>
        <p>
          VEMO como responsable o encargado del tratamiento de datos personales
          cumple los deberes y obligaciones establecidos en los artículos 17 y
          18 de la LGPDP:
        </p>
        <ol type="a">
          <li>
            Garantizar al titular, en todo tiempo, el pleno y efectivo ejercicio
            del derecho de Hábeas Data;
          </li>
          <li>
            Solicitar y conservar, en las condiciones previstas en la presente
            ley, copia de la respectiva autorización otorgada por el titular;
          </li>
          <li>
            Informar debidamente al titular sobre la finalidad de la recolección
            y los derechos que le asisten por virtud de la autorización
            otorgada;
          </li>
          <li>
            Conservar la información bajo las condiciones de seguridad
            necesarias para impedir su adulteración, pérdida, consulta, uso o
            acceso no autorizado o fraudulento;
          </li>
          <li>
            Garantizar que la información que se suministre al encargado del
            tratamiento sea veraz, completa, exacta, actualizada, comprobable y
            comprensible; Actualizar la información, comunicando de forma
            oportuna al encargado del tratamiento, todas las novedades respecto
            de los datos que previamente le haya suministrado y adoptar las
            demás medidas necesarias para que la información suministrada a este
            se mantenga actualizada;
          </li>
          <li>
            Rectificar la información cuando sea incorrecta y comunicar lo
            pertinente al encargado del tratamiento;
          </li>
          <li>
            Suministrar al encargado del tratamiento, según el caso, únicamente
            datos cuyo tratamiento esté previamente autorizado de conformidad
            con lo previsto en la LGPDP;
          </li>
          <li>
            Exigir al encargado del tratamiento en todo momento, el respeto a
            las condiciones de seguridad y privacidad de la información del
            titular;
          </li>
          <li>
            Tramitar las consultas y reclamos formulados en los términos
            señalados en la LGPDP;
          </li>
          <li>
            Adoptar un manual interno de políticas y procedimientos para
            garantizar el adecuado cumplimiento de la LGPDP y en especial, para
            la atención de consultas y reclamos;
          </li>
          <li>
            Informar al encargado del tratamiento cuando determinada información
            se encuentra en discusión por parte del titular, una vez se haya
            presentado la reclamación y no haya finalizado el trámite
            respectivo;
          </li>
          <li>
            Informar a solicitud del titular sobre el uso dado a tus datos;
          </li>
          <li>
            Informar a la autoridad de protección de datos Superintendencia de
            Industria y Comercio (“SIC”), cuando se presenten violaciones a los
            códigos de seguridad y existan riesgos en la administración de la
            información de los titulares.
          </li>
          <li>
            Cumplir las instrucciones y requerimientos que imparta la SIC.
          </li>
        </ol>
      </li>
      <li>
        <h2>
          FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES – PARA QUÉ USAMOS TUS
          DATOS PERSONALES
        </h2>
        <ol type="a">
          <li>
            Utilizar los datos suministrados en campañas de comunicación,
            divulgación y promoción u oferta de productos, actividades y/o
            servicios desarrollados como parte de estrategias internas de VEMO.
          </li>
          <li>
            Envío de comunicaciones a través de cualquier canal incluyendo, pero
            sin limitarse a, redes sociales, mensajes de texto, notificaciones
            push, correo electrónico, llamada telefónica, etc., relacionadas con
            el objeto social de VEMO, tales como a actividades de mercadeo y/o
            cualquier solicitud realizada por el titular a VEMO, y gestionar la
            relación entre usted y la Compañía.
          </li>
          <li>
            Conservar registros históricos de la Compañía y mantener contacto
            con los titulares del dato, respecto de los servicios prestados.
          </li>
          <li>Verificar, comprobar o validar la identidad de los usuarios.</li>
          <li>
            Recabar, tener, manejar y utilizar la información para realizar
            control y prevención del fraude, control y prevención de lavado de
            activos y financiación del terrorismo.
          </li>
          <li>
            Estudiar y analizar la información entregada para el seguimiento y
            mejoramiento del servicio.
          </li>
          <li>
            Realizar de conformidad con la ley los reportes a centrales de
            riesgo (operadores de los bancos de datos personales) por
            incumplimiento de las obligaciones financieras derivadas de la
            relación comercial con VEMO.
          </li>
          <li>
            Llevar a cabo actividades de facturación, aclaraciones y gestionar
            el cobro de sus obligaciones como usuario de nuestros servicios.
            Esto incluye la gestión de cobro prejudicial y judicial, a cargo
            nuestro o de terceros.
          </li>
          <li>
            Celebración, ejecución y gestión de transacciones realizadas a
            través de las aplicaciones o plataformas de nuestros aliados.
          </li>
          <li>
            Adelantar las actividades necesarias para gestionar las solicitudes,
            quejas y reclamos de los usuarios de la Compañía o terceros; y
            direccionarlos a las áreas responsables de emitir las respuestas
            correspondientes.
          </li>
          <li>
            Transmitir la información recolectada a terceros con los que la
            Compañía contrate el almacenamiento y administración de los datos
            personales, bajo los estándares de seguridad y confidencialidad a
            los cuales VEMO está obligada según lo contenido en las leyes
            pertinentes y sus políticas internas.
          </li>
          <li>
            Transferir los datos personales a terceros ubicados en cualquier
            país, que brinde un nivel de protección de datos personales igual o
            mayor al de Colombia.
          </li>
        </ol>
      </li>
      <li>
        <h2>CAMBIOS EN LA POLÍTICA</h2>
        <p>
          En el evento de introducir cambios en la presente política, éstos se
          publicarán en la siguiente dirección electrónica: www.vemovilidad.com
          lo anterior con el fin de mantenerte informado(a) y actualizado(a)
          sobre las condiciones de uso de tus datos. En caso de no estar de
          acuerdo con los cambios efectuados, siéntete libre de ejercer tu
          derecho de habeas data a través de los canales establecidos en esta
          política.
        </p>
      </li>
      <li>
        <h2>TRATAMIENTO DE DATOS SENSIBLES</h2>
        <p>
          Solo procesaremos datos personales sensibles para lo estrictamente
          necesario, solicitando el consentimiento previo y explícito a los
          titulares (representantes legales, apoderados, causahabientes) e
          informándoles sobre la finalidad exclusiva para su tratamiento.
          Trataremos datos de tipo sensible en las siguientes circunstancias:
        </p>
        <ul>
          <li>
            El tratamiento haya sido autorizado expresamente por el titular de
            los datos sensibles, salvo en los casos que, por Ley, no se requiera
            el otorgamiento de dicha autorización.
          </li>
          <li>
            El tratamiento sea necesario para salvaguardar el interés vital del
            titular y este se encuentre física o jurídicamente incapacitado. En
            estos eventos, los representantes legales deberán otorgar la
            autorización.
          </li>
          <li>
            El tratamiento se refiera a datos que sean necesarios para el
            reconocimiento, ejercicio o defensa de un derecho en un proceso
            judicial;
          </li>
          <li>
            El tratamiento que tenga una finalidad histórica, estadística o
            científica o, dentro del marco de procesos de mejoramiento; este
            último, siempre y cuando se adopten las medidas conducentes a la
            supresión de identidad de los titulares o el dato este disociado, es
            decir, el dato sensible sea separado de la identidad del titular y
            no sea identificable o no se logre identificar a la persona titular
            del dato o datos sensibles.
          </li>
        </ul>
        <p>VEMO siempre:</p>
        <ul>
          <li>
            Informa que por tratarse de datos sensibles no está obligado a
            autorizar su tratamiento.
          </li>
          <li>
            Informa de forma explícita y previa, además de los requisitos
            generales de la autorización para la recolección de cualquier tipo
            de dato personal, cuáles datos objeto de tratamiento son de carácter
            sensible, la finalidad aplicada, y obtener tu consentimiento
            explícito.
          </li>
          <li>
            No condicionar ninguna actividad a que nos suministre datos
            personales sensibles (salvo que exista una causa legal o contractual
            para hacerlo).
          </li>
        </ul>
      </li>
      <li>
        <h2>TRATAMIENTO DE DATOS DE NIÑAS, NIÑAS Y ADOLESCENTES.</h2>
        <p>
          VEMO solo tratará los datos personales de menores de edad cuando: (i)
          Sean de naturaleza pública, (ii) provengan de la información
          suministrada por empleados o contratistas, (iii) al momento de la
          prestación de servicios, específicamente durante el arrendamiento y
          uso de los vehículos o (iv) cuando su tratamiento se encuentre
          debidamente autorizado por los padres o representantes legales de la
          niña, niño o adolescente.
        </p>
        <br />
        <p>
          El tratamiento siempre cumplirá con los siguientes parámetros y
          requisitos:
        </p>
        <ul>
          <li>
            Que responda y respete el interés superior de los niños, niñas y
            adolescentes.
          </li>
          <li>Que se asegure el respeto de sus derechos fundamentales.</li>
        </ul>
      </li>
      <li>
        <h2>TRANSMISIÓN DE DATOS PERSONALES A TERCEROS</h2>
        <p>
          No entregaremos tus datos personales a otras entidades sin antes
          obtener su previo consentimiento. Ahora bien, se podrá realizar la
          transmisión cuando:
        </p>
        <ul>
          <li>
            La transmisión de tus datos fuese necesaria para la prestación
            efectiva y cumplimiento de nuestras obligaciones contractuales;
          </li>
          <li>
            Sea necesaria para permitir a los proveedores, contratistas o
            colaboradores prestar los servicios encomendados;
          </li>
          <li>
            Sea necesario para permitir que terceros que prestan servicios de
            marketing en nuestro nombre o a otras entidades con las cuales
            tengamos acuerdos de mercado conjunto;
          </li>
          <li>Sea requerido o permitido por la ley.</li>
        </ul>
        <p>
          Sin perjuicio de lo anterior, para realizar una transmisión de tus
          datos personales a terceros encargados ubicados en Colombia o en el
          exterior, debe existir (i) una autorización previa, expresa e
          informada por parte suya, o (ii) un contrato de transmisión de datos
          personales que contenga por lo menos lo siguiente:
        </p>
        <ul>
          <li>
            Los alcances de las obligaciones del encargado del tratamiento de
            datos personales.
          </li>
          <li>
            Las actividades que el encargado deberá realizar por nuestra cuenta
            con tu información personal.
          </li>
          <li>
            Las obligaciones del encargado con respecto al titular y VEMO.
          </li>
          <li>
            La obligación del encargado de dar cumplimiento a las obligaciones
            contempladas en el aviso de privacidad y el manual interno de
            políticas y nuestros procedimientos.
          </li>
          <li>
            La obligación del encargado de realizar el tratamiento de los datos
            personales de acuerdo con las finalidades autorizadas por los
            titulares y con legislación aplicable.
          </li>
          <li>
            La obligación del encargado de dar tratamiento, por cuenta del
            responsable, a los datos personales conforme a los principios que
            los tutelan.
          </li>
          <li>
            La obligación del encargado de salvaguardar la seguridad de las
            bases de datos en los que se contengan datos personales.
          </li>
          <li>
            La obligación del encargado de guardar confidencialidad respecto del
            tratamiento de los datos personales.
          </li>
        </ul>
      </li>
      <li>
        <h2>TRANSFERENCIA DE DATOS PERSONALES A TERCEROS PAÍSES</h2>
        <p>
          Se considera una transferencia internacional cualquier tratamiento que
          suponga una envío de datos personales fuera del territorio colombiano.
          La transferencia de tus datos personales a terceros países solamente
          se realizará cuando exista autorización previa, expresa e informada
          del titular, y el país cuente con un nivel adecuado de protección de
          datos personales de conformidad con la SIC.
        </p>
        <br />
        <p>
          Sin embargo, cuando ocurra cualquiera de las siguientes circunstancias
          se podrá enviar los datos personales a países que no cuente con un
          nivel adecuado de protección de datos personales cuando:
        </p>
        <ul>
          <li>
            Se tenga la autorización previa, expresa, informada e inequívoca del
            titular.
          </li>
          <li>
            Intercambio de datos personales de carácter médico cuando exista una
            emergencia que así lo exija.
          </li>
          <li>
            Transferencias bancarias o bursátiles, conforme a la legislación que
            les resulte aplicable;
          </li>
          <li>
            Transferencias acordadas en el marco de tratados internacionales en
            los cuales la República de Colombia sea parte, con fundamento en el
            principio de reciprocidad;
          </li>
          <li>
            Transferencias necesarias para la ejecución de un contrato entre el
            Titular y el Responsable del Tratamiento, o para la ejecución de
            medidas precontractuales siempre y cuando se cuente con la
            autorización del Titular;
          </li>
          <li>
            Transferencias legalmente exigidas para la salvaguardia del interés
            público, o para el reconocimiento, ejercicio o defensa de un derecho
            en un proceso judicial.
          </li>
          <li>Cuando la SIC emita una declaración de conformidad.</li>
        </ul>
      </li>
      <li>
        <h2>SEGURIDAD Y CONFIDENCIALIDAD</h2>
        <p>
          Con el fin de cumplir con el principio de seguridad, implementamos
          mecanismos internos de seguridad de la información para evitar su
          adulteración, pérdida, consulta, uso o acceso no autorizado o
          fraudulento, que son de obligatorio acatamiento por parte de los
          destinatarios de estas políticas.
        </p>
        <br />
        <p>
          Tus datos personales serán tratados con total reserva y
          confidencialidad, comprometiéndonos a guardar el debido secreto
          respecto de estos y garantizando el deber de almacenarlos adoptando
          medidas necesarias que eviten su alteración, pérdida y tratamiento o
          acceso no autorizado de acuerdo con lo establecido en la legislación
          aplicable.
        </p>
      </li>
      <li>
        <h2>INFORMACIÓN DE CONTACTO</h2>
        <table>
          <tr>
            <td>Dirección</td>
            <td>Calle 93 No. 15-40 Piso 4</td>
          </tr>
          <tr>
            <td>Correo Electrónico</td>
            <td>Yolanda.villegas@vemo.com.mx</td>
          </tr>
          <tr>
            <td>Sitio Web</td>
            <td><a href="www.vemovilidad.com ">www.vemovilidad.com</a></td>
          </tr>
          <tr></tr>
        </table>
      </li>
      <li>
        <h2>VIGENCIA.</h2>
        <p>
          La presente Política entra en vigencia a partir de 01 de Marzo de
          2023.
        </p>
      </li>
    </ol>
  </div>
  <div class="button-close">
    <button mat-raised-button [mat-dialog-close]="true">Cerrar</button>
  </div>
</div>
